import axios from 'axios';

import getLogger from '../util/logger';
import getConfig from '../util/config';

const log = getLogger('Authentication');

export const AUTH_LOGIN_REQUEST = 'auth/AUTH_LOGIN_REQUEST';
export const AUTH_LOGIN_SUCCESS = 'auth/AUTH_LOGIN_SUCCESS';
export const AUTH_LOGIN_FAILURE = 'auth/AUTH_LOGIN_FAILURE';

export const AUTH_LOGOUT_REQUEST = 'auth/AUTH_LOGOUT_REQUEST';
export const AUTH_LOGOUT_SUCCESS = 'auth/AUTH_LOGOUT_SUCCESS';
export const AUTH_LOGOUT_FAILURE = 'auth/AUTH_LOGOUT_FAILURE';

export const loginRequest = () => {
  return { type: AUTH_LOGIN_REQUEST };
};

export const loginSuccess = () => {
  return { type: AUTH_LOGIN_SUCCESS };
};

export const loginFailure = error => {
  return { type: AUTH_LOGIN_FAILURE, error };
};

export const logoutRequest = () => {
  return { type: AUTH_LOGOUT_REQUEST };
};

export const logoutSuccess = () => {
  return { type: AUTH_LOGOUT_SUCCESS };
};

export const logoutFailure = error => {
  return { type: AUTH_LOGOUT_FAILURE, error };
};

export const logoutAction = ({ redirectUrl } = {}) => async dispatch => {
  const config = getConfig();
  dispatch(logoutRequest());

  try {
    // Don't dispatch logoutSuccess because we're refreshing the page.
    await axios.post('/auth/request-logout/');

    if (window.location) {
      window.location = redirectUrl || config.app.baseUrl;
    }
  } catch (error) {
    log.error('logout() :: Error:', error);
    dispatch(logoutFailure(error));
  }
};
